const CategorySangPageORGFA = [
    {
        ID : 60 ,
        Name: " سنگ تراورتن ",
        ImageURL: "image/Stone/1-2.jpg",
        CategoryID: 1001 ,
        Details: "کرم نسکافه ای ممتاز " ,
        CompanyName: "ابرکوه" , 
    },
    {
        ID : 138 ,
        Name: " مرمریت  ",
        ImageURL: "image/Stone/4-35.jpeg",
        CategoryID: 1002,
        Details: "بلک 40 طولی" ,
        CompanyName: "نجف آباد" , 
    },
    {
        ID : 145 ,
        Name: " سنگ گرانیت",
        ImageURL: "image/Stone/2-5.jpg",
        CategoryID: 1003,
        Details: "نهبندان" ,
        CompanyName: "_" , 
    },
    {
        ID : 64 ,
        Name: " سنگ مرمر ",
        ImageURL: "image/new-cat-2-6.jpeg",
        CategoryID: 1004,
        Details: "" ,
        CompanyName: "_" , 
    },
]

export default CategorySangPageORGFA;